<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div">
      <div class="list-header-title-div">698小红书分享活动记录</div>

      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="handleExport">导 出</button>
        <button class="common-bg-button" @click="showMultiQuerys = !showMultiQuerys">
          {{ showMultiQuerys ? "收起筛选" : "高级筛选" }}
        </button>
      </div>

      <!-- 筛选区：本仓惯例是折叠 + el-row/el-col 三列栅格，不用 el-form inline -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <el-row :gutter="20">
          <el-col :span="8">
            <p class="margin-bottom-5 font-14">活动订单号</p>
            <el-input clearable size="small" v-model="queryInfo.orderNo" placeholder="精确匹配，请输入完整订单号"></el-input>
          </el-col>
          <el-col :span="8">
            <p class="margin-bottom-5 font-14">用户账号</p>
            <el-input clearable size="small" v-model="queryInfo.userId" placeholder="模糊匹配，小程序账号 userId"></el-input>
          </el-col>
          <el-col :span="8">
            <p class="margin-bottom-5 font-14">手机号</p>
            <el-input clearable size="small" v-model="queryInfo.mobile" placeholder="模糊匹配"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="margin-top-15">
          <el-col :span="8">
            <p class="margin-bottom-5 font-14">小红书活动状态</p>
            <el-select clearable size="small" style="width: 100%" v-model="queryInfo.status" placeholder="请选择状态">
              <el-option v-for="(text, code) in pageConfig.statusMap" :key="code" :label="text" :value="code" />
            </el-select>
          </el-col>
          <el-col :span="8">
            <p class="margin-bottom-5 font-14">奖励发放状态</p>
            <el-select clearable size="small" style="width: 100%" v-model="queryInfo.grantStatus" placeholder="请选择发放状态">
              <el-option label="已发放" value="GRANTED" />
              <el-option label="未发放" value="UNGRANTED" />
            </el-select>
          </el-col>
          <el-col :span="8">
            <p class="margin-bottom-5 font-14">笔记提交时间</p>
            <el-date-picker
              class="full-width"
              size="small"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              v-model="submitTimeRange"
              @change="pickSubmitDate"
            ></el-date-picker>
          </el-col>
        </el-row>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
        </div>
      </div>

      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }">
          <!-- 7. 小红书推文链接：截断显示 + 点击新窗口直达 + 复制完整 URL -->
          <template slot="noteUrl" slot-scope="{ row }">
            <span v-if="!row.noteUrl">-</span>
            <span v-else class="link-cell">
              <a class="link-text" :title="row.noteUrl" @click="openNoteUrl(row.noteUrl)">{{ row.noteUrl }}</a>
              <button class="mini-btn plain" @click="copyText(row.noteUrl)">复制</button>
            </span>
          </template>

          <!-- 1. 活动订单编号：点击进订单详情（原型同款；详情页 tab 名见 anxinPackActivity/detail.vue） -->
          <template slot="activityOrderNo" slot-scope="{ row }">
            <a v-if="row.activityOrderNo" class="link-text" :title="row.activityOrderNo"
              @click="goOrderDetail(row, 'order')">{{ row.activityOrderNo }}</a>
            <span v-else>-</span>
          </template>

          <!-- 14. 剩余展示天数：按原型 `>0 → N 天，否则「已满足」`（空值给 '-'） -->
          <template slot="showRemainingDays" slot-scope="{ row }">
            <span v-if="row.showRemainingDays === null || row.showRemainingDays === undefined">-</span>
            <span v-else>{{ row.showRemainingDays > 0 ? row.showRemainingDays + " 天" : "已满足" }}</span>
          </template>

          <!-- 16/19/20：空值统一给 '-'（原型同款；空着看不出是没数据还是渲染漏了） -->
          <template slot="grantMonths" slot-scope="{ row }">
            {{ row.grantMonths === null || row.grantMonths === undefined ? '-' : row.grantMonths }}
          </template>
          <template slot="grantUserName" slot-scope="{ row }">{{ row.grantUserName || '-' }}</template>
          <template slot="grantTime" slot-scope="{ row }">{{ row.grantTime || '-' }}</template>

          <!-- 18. 服务费支付流水号：PRD §3.2.1 #18 要求可跳转订单详情-平台服务费信息 -->
          <template slot="feeRecordId" slot-scope="{ row }">
            <a v-if="row.feeRecordId" class="link-text" :title="row.feeRecordId"
              @click="goOrderDetail(row, 'flow')">{{ row.feeRecordId }}</a>
            <span v-else>-</span>
          </template>

          <!-- 9. 小红书活动状态：带颜色的 el-tag，配色与后台原型 XHS_STATUS_CLASS 一致 -->
          <template slot="status" slot-scope="{ row }">
            <el-tag :type="statusTagType[row.status] || 'info'" size="small">
              {{ statusMap[row.status] || row.status || "-" }}
            </el-tag>
          </template>

          <!-- 17. 奖励发放状态：已发放 success（绿）、其余 info（灰） -->
          <template slot="grantStatusDesc" slot-scope="{ row }">
            <el-tag :type="grantStatusTagType(row)" size="small">
              {{ row.grantStatusDesc || "未发放" }}
            </el-tag>
          </template>

          <!-- 8. 推文截图：后端给 3 个字段，合并成一列；点击预览大图 -->
          <template slot="screenshots" slot-scope="{ row }">
            <div class="screenshot-cell">
              <img
                v-for="item in screenshotsOf(row)"
                :key="item.key"
                class="screenshot-thumb"
                :src="item.url"
                :title="item.label + '：点击查看大图'"
                @click="viewImage(item.url)"
              />
              <span v-if="!screenshotsOf(row).length">-</span>
            </div>
          </template>

          <!-- 13. 展示期起止：起 ~ 止 -->
          <template slot="showPeriod" slot-scope="{ row }">
            <span v-if="!row.showStartTime && !row.showEndTime">-</span>
            <span v-else>{{ row.showStartTime || "-" }} ~ {{ row.showEndTime || "-" }}</span>
          </template>

          <!-- 21. 操作：按钮状态机由后端派生（canAudit/canGrant/canRetry），前端只渲染不判断 -->
                    <!-- 21. 操作：按钮组与文案照后台原型 actionHtml（审核中给「审核通过/审核不通过」两个按钮） -->
          <template slot="operate" slot-scope="{ row }">
            <template v-if="row.canAudit">
              <button class="mini-btn" @click="openAuditDialog(row, 'pass')">审核通过</button>
              <button class="mini-btn danger" @click="openAuditDialog(row, 'reject')">审核不通过</button>
            </template>
            <button v-else-if="row.canGrant" class="mini-btn warn" @click="openGrantDialog(row)">去发放奖励</button>
            <button v-else-if="row.canRetry" class="mini-btn" @click="handleRetry(row)">重试发放</button>
            <template v-else>
              <button class="mini-btn" disabled :title="actionTitle(row)">{{ actionLabel(row) }}</button>
            </template>
          </template>
        </ZD-table>
      </div>

      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>

      <!-- 审核弹窗（ADM-3）/ 发放弹窗（ADM-4）：抽成共享组件，与「订单详情-小红书 Tab」共用 -->
      <XhsAuditDialog :visible.sync="auditVisible" :row="actionRow" :mode="auditMode" @success="onActionSuccess" />
      <!-- 发放奖励：复用「配置服务费」弹窗（来源锁死活动赠送、月数进来就是预期奖励月数），
           确认仍打 698 发放接口——不另建一套发放弹窗 -->
      <FeeConfigDialog
        :visible.sync="grantVisible"
        :user-name="actionRow && actionRow.userName"
        :user-mobile="actionRow && actionRow.mobile"
        :mask-mobile="false"
        :activity-name="actionRow && actionRow.activityName"
        lock-gift-type="ACTIVITY_GIFT"
        :preset-months="actionRow && actionRow.expectedMonths"
        :unit-price="actionRow && actionRow.serviceUnitPrice"
        :submitting="grantSubmitting"
        @submit="submitGrant"
      />

      <!-- 图片预览 -->
      <el-dialog :visible.sync="imageDialogVisible" width="720px" append-to-body title="截图预览">
        <img v-if="imageUrl" :src="imageUrl" style="width: 100%" alt="截图" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pageConfig, { fileUrl, statusTagType, grantStatusTagType } from "./page-config";
import XhsAuditDialog from "./xhs-audit-dialog.vue";
import FeeConfigDialog from "../components/FeeConfigDialog.vue";

export default {
  name: "XhsActivityList",
  components: { XhsAuditDialog, FeeConfigDialog },
  data() {
    return {
      pageConfig,
      statusMap: pageConfig.statusMap,
      statusTagType,
      tableData: [],
      selections: [],
      // 空表时给个明确说法，避免「有数据但页面空着」时无从判断
      loadState: 'loading', // loading | ok | fail
      operates: { list: [] },
      pagination: { ...pageConfig.pagination }, // 展开副本，避免改到配置对象
      queryInfo: {},
      showMultiQuerys: false,
      submitTimeRange: [],
      // 审核 / 发放弹窗（内容与提交逻辑在共享组件内）
      auditVisible: false,
      auditMode: 'pass', // 审核通过 / 审核不通过（由行内两个按钮决定，原型同款）
      grantVisible: false,
      grantSubmitting: false,
      actionRow: null,
      // 图片预览
      imageDialogVisible: false,
      imageUrl: "",
    };
  },
  computed: {
    tableConfig() {
      const state = this.loadState;
      const text = state === 'loading' ? '加载中…' : state === 'fail' ? '加载失败：请看控制台 [xhs-list] 或 Network 里该接口的状态码' : '暂无数据';
      return { ...pageConfig.tableConfig, emptyText: text };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 模板里要用到它：page-config 的**导出函数不会自动挂到组件实例上**，必须放进 methods，
    // 否则模板求值时是 undefined → is not a function → 表体渲染整块失败（页面表现就是「没数据」）。
    grantStatusTagType,

    init() {
      this.getListData(this.pagination, true);
    },

    /** 全仓统一签名：getListData(pagination, reload) —— 与安心包活动列表同款写法 */
    getListData(pagination, reload = false) {
      const _ = this;
      _.loadState = 'loading';
      _.$U.showLoading(_);
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      } else {
        _.pagination.current = pagination.current;
        // 后端约定 pageNum 为 1-based，此处不做 -1
        _.queryInfo.pageNum = Number(pagination.current);
      }
      _.queryInfo.pageSize = pagination.pageSize || _.pagination.pageSize;
      _.pagination.pageSize = _.queryInfo.pageSize;

      const params = {
        ..._.cleanQueryInfo(_.queryInfo),
        corpNo: _.$store?.state?.corpNo,
        pageNum: _.queryInfo.pageNum,
        pageSize: _.pagination.pageSize,
      };

      _.$H.post(_, _.$A.xhsActivity.page, params).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        _.tableData = payload?.content ?? payload?.list ?? payload?.records ?? [];
        _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
        _.loadState = 'ok';
      }).catch((err) => {
        // TODO(临时排查): 定因后删。请求被网关拦掉（如权限不足返回 500）会走到这里
        console.warn('[xhs-list] 请求失败', err?.response?.status, err?.response?.data);
        _.tableData = [];
        _.pagination.total = 0;
        _.loadState = 'fail';
      }).finally(() => {
        _.$U.hideLoading(_);
      });
    },

    /** 去掉空字符串/空值筛选项，避免后端把 "" 当条件 */
    cleanQueryInfo(queryInfo) {
      const clean = {};
      Object.keys(queryInfo || {}).forEach((key) => {
        const value = queryInfo[key];
        if (value !== null && value !== undefined && value !== "") {
          clean[key] = value;
        }
      });
      return clean;
    },

    reset() {
      this.queryInfo = {};
      this.submitTimeRange = [];
      this.getListData(this.pagination, true);
    },

    /** 提交时间区间 → submitFrom / submitTo */
    pickSubmitDate(range) {
      this.queryInfo.submitFrom = range ? range[0] : "";
      this.queryInfo.submitTo = range ? range[1] : "";
    },

    // ===================== 列表列渲染辅助 =====================

    /** 推文截图：后端给 3 个独立字段，合并为一列的缩略图（只渲染有值的） */
    screenshotsOf(row) {
      const list = [];
      if (row.screenshotAccount) list.push({ key: "account", label: "账号截图", url: fileUrl(row.screenshotAccount) });
      if (row.screenshotPublish) list.push({ key: "publish", label: "发布详情截图", url: fileUrl(row.screenshotPublish) });
      if (row.screenshotNote) list.push({ key: "note", label: "笔记截图", url: fileUrl(row.screenshotNote) });
      return list;
    },

    ellipsis(text, max) {
      if (!text) return "";
      return text.length > max ? text.slice(0, max) + "..." : text;
    },

    /**
     * 跳订单详情页。tab 用详情页的页签名：
     *   order = 订单信息（活动订单编号）· flow = 平台服务费信息（服务费支付流水号，PRD §3.2.1 #18）
     */
    goOrderDetail(row, tab) {
      if (!row || !row.activityOrderNo) return;
      this.$router.push({
        path: "/anxinPackActivityDetail",
        query: {
          orderNo: row.activityOrderNo,
          activityType: "AXB_698_ACTIVITY_PAY", // 本活动固定 698 安心包用桩
          tab: tab || "order",
        },
      });
    },

    openNoteUrl(url) {
      if (url) window.open(url, "_blank");
    },

    /**
     * 复制完整链接。优先用 clipboard API（https 下才能用），
     * 不可用时回退到 execCommand —— 原来只用 execCommand，个别浏览器/非安全上下文会静默失败。
     */
    copyText(text) {
      if (!text) return;
      const done = () => this.$U.success("已复制链接");
      const fallback = () => {
        const input = document.createElement("input");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        done();
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(fallback);
      } else {
        fallback();
      }
    },

    viewImage(url) {
      if (!url) return;
      this.imageUrl = url;
      this.imageDialogVisible = true;
    },

    // ===================== 审核 / 发放（ADM-3 / ADM-4）=====================
    // 审核弹窗本体在 xhs-audit-dialog；发放弹窗复用共享的「配置服务费」弹窗
    // （../components/FeeConfigDialog.vue），本页只负责「哪一行」与提交
    /** 操作列文案/提示：照原型——展示中未满 15 天显示「耐心等待发放」，剩余天数放 title */
    actionLabel(row) {
      if (row.status === 'showing' && row.showRemainingDays > 0) return '耐心等待发放';
      return pageConfig.statusMap[row.status] || '—';
    },
    actionTitle(row) {
      if (row.status === 'showing' && row.showRemainingDays > 0) {
        return '推文需保持展示 15 天，剩余 ' + row.showRemainingDays + ' 天可发放';
      }
      return row.operationDisabledReason || '';
    },
    openAuditDialog(row, mode) {
      this.actionRow = row;
      this.auditMode = mode === 'reject' ? 'reject' : 'pass';
      this.auditVisible = true;
    },

    openGrantDialog(row) {
      this.actionRow = row;
      this.grantVisible = true;
    },

    /**
     * 发放确认：弹窗里的「服务费配置周期」即实际奖励月数（默认已预填预期月数，运营可改）。
     * 赠送来源不提交——后端 /xhsActivity/admin/grant 固定用 ACTIVITY_GIFT，前端锁定只是 UI 约束。
     */
    submitGrant(payload) {
      const _ = this;
      const row = _.actionRow || {};
      _.grantSubmitting = true;
      _.$H.post(_, _.$A.xhsActivity.grant, {
        noteNo: row.noteNo,
        actualMonths: payload.giftMonths,
      })
        .then(() => {
          _.$U.success("发放完成");
          _.grantVisible = false;
          _.onActionSuccess();
        })
        .finally(() => {
          _.grantSubmitting = false;
        });
    },

    /** 审核 / 发放成功后刷新列表（弹窗组件已提示成功并自行关闭） */
    onActionSuccess() {
      this.getListData(this.pagination, true);
    },

    /** 重试发放：仅后端判定为「发放失败 / 占位陈旧」的行才会出现该按钮 */
    handleRetry(row) {
      const _ = this;
      _.$confirm("确认重试发放？将按实际奖励月数重新出账。", "二次确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _.$U.showLoading(_);
          return _.$H
            .post(_, _.$A.xhsActivity.grantRetry, {
              noteNo: row.noteNo,
              actualMonths: row.grantMonths || row.expectedMonths || undefined,
            })
            .then(() => {
              _.$U.success("重试成功");
              _.getListData(_.pagination, true);
            })
            .finally(() => {
              _.$U.hideLoading(_);
            });
        })
        .catch(() => {
          // 用户取消二次确认，不做额外提示
        });
    },

    // ===================== 导出 =====================

    handleExport() {
      const _ = this;
      _.$U.showLoading(_);
      const exportQueryInfo = {
        ..._.cleanQueryInfo(_.queryInfo),
        corpNo: _.$store && _.$store.state ? _.$store.state.corpNo : undefined,
        // 导出剥离分页参数：后端按全量命中结果导出
        pageNum: undefined,
        pageSize: undefined,
      };

      _.$H.post(_, _.$A.xhsActivity.excel, exportQueryInfo)
        .then((res) => {
          const payload = (res && res.data && res.data.data) || (res && res.data) || {};
          const filePath = payload.filePath;
          if (!filePath) {
            _.$U.error("导出失败：未获取到文件路径");
            return;
          }
          // 与全仓导出约定一致：后端 viewpath=/files/ 返回的是**相对路径**，需拼文件服务器前缀。
          // 不能用 window.location.origin —— 开发环境能通只是因为 vue.config.js 代理了 /files，
          // 生产环境会 404。此处域名分支照既有页面（giftRecord）的写法，属历史遗留坏味道。
          const host = window.location.hostname;
          const fileHost =
            host.indexOf("shzhida.com") >= 0
              ? "http://ocharge.shzhida.com:6771"
              : "http://192.168.8.174:7997";
          const url = filePath.indexOf("http") === 0 ? filePath : fileHost + filePath;
          window.open(url, "_blank");
          _.$U.success("导出成功");
        })
        .finally(() => {
          _.$U.hideLoading(_);
        });
    },
  },
};
</script>

<style scoped>
.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}
.margin-top-15 {
  margin-top: 15px;
}
.link-text {
  color: #409eff;
  cursor: pointer;
  word-break: break-all;
  flex: 1;
  min-width: 0;
}
/* 链接 + 「复制」按钮：链接折行占满、复制按钮固定不遮挡 */
.link-cell {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.link-cell .mini-btn {
  flex-shrink: 0;
}
.screenshot-cell {
  display: flex;
  gap: 4px;
  justify-content: center;
}
.screenshot-thumb {
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  cursor: pointer;
}
.operate-none {
  color: #909399;
}
.form-tip {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}

/* 操作列按钮：照后台原型 .mini-btn（自绘小按钮，不用 el-button，版式才一致） */
.mini-btn {
  padding: 3px 9px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #1677ff;
  background: #1677ff;
  color: #fff;
}
.mini-btn.plain {
  background: #fff;
  color: #1677ff;
}
.mini-btn.danger {
  background: #fff;
  color: #f56c6c;
  border-color: #f56c6c;
}
.mini-btn.warn {
  background: #e6a23c;
  border-color: #e6a23c;
  color: #fff;
}
.mini-btn:disabled {
  background: #f5f7fa;
  color: #c0c4cc;
  border-color: #e5e8ef;
  cursor: not-allowed;
}
.mini-btn + .mini-btn {
  margin-left: 6px;
}
</style>
